import React from "react";
import { Row, Col, Space, Tooltip, message, Button, Modal } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import ListTable from "./ListTable";

import config from "../config";

import withRouter from "../withRouter";
import DeleteConfirm from "./DeleteConfirm";
import { ProjectOutlined, DeleteFilled, PlusOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import CompanyStore from "../store/CompanyStore";
import ProjectStore from "../store/ProjectStore";
import ProjectAdd from "./ProjectAdd";
import projectStore from "../store/ProjectStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import AssignVehicleToCompany from "./AssignVehicleToCompany";
import AssignProjectToDriver from "./AssignProjectToDriver";

class Project extends React.Component {
    constructor(props) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.companyStore = new CompanyStore(this);
        this.projectStore = new ProjectStore(this);
        this.handleChange = this.handleChange.bind(this);
        this.projectStore = new projectStore();

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            loadData: 1,
            companyId: "",
            comp_value: "",
            listDataUpdate: false,
            openAssignForm: false,
            openProjectForm: false,
            projectId: "",
            projectIdEdit: "",
        };
    }
    async componentDidUpdate(prevProps, prevState) {
        if (prevState.listDataUpdate !== this.state.listDataUpdate) {
            await this.handleSearch();
            await this.setState({ loadList: 1 });
            await this.setState({ listDataUpdate: false });
        }
    }
    async componentDidMount() {
        this.setState({ pageSize: 50, loadData: 1 });
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({ companyId: this.props.getUserData().userCompanyId});
            await this.handleSearch();

        }
        // const data = await this.projectStore.getProjectDetails(
        //     this.props.getUserData().userCompanyId
        // );
        this.columns = [
            {
                title: this.context.translate("_PROJECT_NAME_"),
                dataIndex: "projectName",
                width: "10%",
                render: (val, record) => {
                    return (
                        <Link
                            onClick={(e) => {
                                e.preventDefault();
                                this.onEdit(record);
                            }}
                        >
                            {val}
                        </Link>
                    );
                },
            },
            {
                title: this.context.translate("_ACTION_"),
                dataIndex: "action",
                width: "5%",
                render: (_, record) => {
                    return (
                        <>
                            <Space>
                                <DeleteConfirm
                                    onConfirm={(e) => {
                                        e.preventDefault();
                                        this.onDelete(record);
                                    }}
                                >
                                    <Tooltip
                                        placement="bottom"
                                        // title="Delete Record"
                                        title={this.context.translate("_DELETE_RECORD_")}
                                        color={config.tooltipColorDelete}
                                    >
                                        <DeleteFilled style={{ color: config.deleteColor }} />
                                    </Tooltip>
                                </DeleteConfirm>
                                <Link
                                   
                                    onClick={async() => {
                                        this.onAssign(record);
                                    //   await  this.setState({
                                    //         openAssignForm: true,
                                    //         projectIdEdit: record.projectId,
                                    //     });
                                    }}
                                >
                                    {" "}
                                    <Tooltip
                                        // title="Assign"
                                        title={this.context.translate("_ASSIGN_")}
                                        placement="bottom"
                                        color={config.tooltipColorEdit}
                                    >
                                        <ProjectOutlined />
                                    </Tooltip>
                                </Link>
                            </Space>
                        </>
                    );
                },
            },
        ];
    }

    onEdit = async (record) => {
        console.log(record)
        await this.setState({ projectIdEdit: record.projectId });
        console.log(this.state.projectIdEdit)
        await this.setState({ openProjectForm: true });
    };
    onAssign = async (record) => {
        console.log(record)
        await this.setState({ projectIdEdit: record.projectId });
        await this.setState({ openAssignForm: true });
        console.log(
            this.state.projectIdEdit
        )
    };
    async handleChange(comp) {
        await this.setState({
            companyId: comp.value,
            currentPage: 1,
            pageSize: 50,
        });
        const singleData = await this.companyStore.getCompanyDataById(comp.value);
        console.log(singleData);

        await this.setState({ comp_value: singleData });

        await this.handleSearch();
        await this.setState({ loadList: 1 });
    }
    async onDelete(record) {
        const response = await this.projectStore.deleteRecord({
            id: record.projectId,
        });

        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.handleSearch();
        } else {
            message.error(response.data.message);
        }
    }

    async handleSearch() {
        this.setState({ loading: true });
        console.log("projectId", this.state.projectId)
        await this.projectStore.getProjectDetails(this.state.companyId, this.state.projectId);
        console.log(this.projectStore.projectList);
        await this.setState({ loadData: 1, loading: false });
    }

    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.handleSearch();
    }

    closeModal = () => {
        this.setState({ openProjectForm: false });
    };

    closeAssignModal = () => {
        this.setState({ openAssignForm: false });
    };
    responseMsg = async (resp) => {
        console.log(resp)
        if (resp.success === "S") {
            message.success(resp.message);
            await this.setState({ listDataUpdate: true });
            await this.setState({ openProjectForm: false });
            await this.handleSearch();
        } else {
            message.error(resp.message);
        }
    };

    render() {
        return (
            <>
                <div style={{ padding: 0 }}>
                    <Row className="headerFixed" style={{ height: "50px" }}>
                        <Col span={12}>
                            <div className="heading">
                                {this.context.translate("_PROJECT_LIST_")}
                            </div>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction == "ltr" ? "right" : "left",
                                }}
                            >
                                <Tooltip
                                    placement="left"
                                    //  title="Add"
                                    title={this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                                    color={config.primaryColor}
                                >
                                    <Button
                                        className="addButton"
                                        icon={<PlusOutlined />}
                                        type="primary"
                                        onClick={() =>
                                            this.setState({
                                                openProjectForm: true,
                                                projectId: "",
                                                projectIdEdit: "",
                                            })
                                        }
                                    ></Button>
                                </Tooltip>                               
                            </Space>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        paddingTop: "10px",
                        paddingRight: "24px",
                        paddingLeft: "24px",
                    }}
                >
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    onChange={this.handleChange}
                                    value={this.state.comp_value ? this.state.comp_value : null}
                                    style={{ width: 200 }}
                                />
                            </Space>
                        </Col>
                    </Row>
                    <ListTable
                        currentPage={this.state.currentPage}
                        total={this.projectStore?.total}
                        columns={this.columns}
                        pageSize={this.state.pageSize}
                        dataSource={this.projectStore?.projectList}
                        loading={this.projectStore?.loading}
                        onChange={this.handleTableChange}
                        rowKey="projectId"
                    />

                </div>

                {this.state.openProjectForm && (
                    <Modal
                        bodyStyle={{ height: "645px" }}
                        className="formShowModal"
                        title={this.context.translate("_PROJECT_")}
                        centered
                        open={this.state.openProjectForm}
                        footer={null}
                        onCancel={() => {
                            this.setState({ openProjectForm: false, projectId: "" });
                        }}
                        width={665}
                    >
                        <div>
                            <ProjectAdd
                                projectId={this.state.projectIdEdit}
                                companyId={this.state.companyId}
                                response={this.responseMsg}
                                closeModal={this.closeModal}
                            />
                        </div>
                    </Modal>
                )}

                {this.state.openAssignForm && (
                    <Modal
                        bodyStyle={{ height: "645px" }}
                        className="formShowModal"
                        title={this.context.translate("_ASSIGN_PROJECT_TO_DRIVER_")}
                        centered
                        visible={this.state.openAssignForm}
                        footer={null}
                        onCancel={() => {
                            this.setState({ openAssignForm: false });
                        }}
                        width={665}
                    >
                        <div>
                            <AssignProjectToDriver
                             projectId={this.state.projectIdEdit}
                             companyId={this.state.companyId }
                             closeModal={this.closeAssignModal}
                             />
                        </div>
                    </Modal>
                )}
            </>
        );
    }
}
Project.contextType = StoreContext;
export default observer(withRouter(Project));
